const Constants = {
  attachmentTypePath: "/attachment-types"
};
const AttachmentType = {
  DECISION: "Odluka"
};
export default Constants;
export { AttachmentType };
